import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import Logo from "assets/images/signality_logo.svg"
const Footer = () => {
  const { t } = useTranslation();
  return (
    <div>
          <footer className="df-footer pt_100">
              {/* Logo */}
              <div className="df-footer-logo text-center">
                  <img src={Logo} alt={t("footer.logoAlt")} />
              </div>

              {/* Navigation Links */}
              <div className="df-footer-nav text-center">
                  <Link to="#">{t("footer.nav.marketInsights")}</Link>
                  <Link to="#">{t("footer.nav.dataSolutions")}</Link>
                  <Link to="#">{t("footer.nav.analyticsTools")}</Link>
                  <Link to="#">{t("footer.nav.clientSupport")}</Link>
                  <Link to="#">{t("footer.nav.contactUs")}</Link>
              </div>

              {/* Divider */}
              <div className="df-footer-divider"></div>

              {/* Legal Links */}
              <div className="df-footer-legal">
                  <Link to="/privacy-policy">{t("footer.legal.privacyPolicy")}</Link>
                  <Link to="/terms-of-service">{t("footer.legal.termsOfService")}</Link>
                  <Link to="/cookies-settings">{t("footer.legal.cookiesSettings")}</Link>
              </div>
          </footer>
    </div>
  )
}

export default Footer
